var render = function render(){var _vm=this,_c=_vm._self._c;return _c('bg-column-list',{attrs:{"label":_vm.label,"sort":_vm.sort,"list":_vm.renderProperties,"is-linear-list":_vm.isLinearList}})
}
var staticRenderFns = []

export { render, staticRenderFns }